import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const StaffRegistrationRejectedPage = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const rejectedSalons = user?.rejectedSalons || [];

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4 dark:bg-zinc-950">
      <div className="w-full max-w-lg rounded-2xl border border-red-200 bg-white p-8 text-center dark:border-red-900/50 dark:bg-zinc-900">
        <p className="text-5xl">✕</p>
        <h1 className="mt-4 text-2xl font-semibold">{t('auth.staffRegister.rejectedTitle')}</h1>
        <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">{t('auth.staffRegister.rejectedDesc')}</p>

        {rejectedSalons.length > 0 && (
          <ul className="mt-4 space-y-2 text-left">
            {rejectedSalons.map((salon) => (
              <li
                key={salon.tenantId}
                className="rounded-lg bg-red-50 px-4 py-3 text-sm dark:bg-red-950/20"
              >
                <p className="font-medium">{salon.businessName}</p>
                <p className="mt-1 text-xs text-zinc-500">{t('auth.staffRegister.declinedBySalon')}</p>
              </li>
            ))}
          </ul>
        )}

        <p className="mt-4 text-xs text-zinc-500">{t('auth.staffRegister.rejectedHelp')}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button
            type="button"
            onClick={() => logout()}
            className="rounded-lg border border-zinc-300 px-4 py-2 text-sm dark:border-zinc-700"
          >
            {t('common.signOut')}
          </button>
          <Link to="/login" className="rounded-lg bg-glow-600 px-4 py-2 text-sm text-white hover:bg-glow-500">
            {t('auth.staffRegister.tryAgain')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StaffRegistrationRejectedPage;
